import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { EditableTextField } from '../common/EditableComponents'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import Text from '../common/Text'
import moment from 'moment'
import { numberWithCommas } from '../../utils/common'

class SubscriptionModal extends PureComponent {
  centerAlign = {
    textAlign: 'center',
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedSource: null,
    }
  }

  state = {
    selectedSource: null,
  }

  componentDidMount() {
    this.setState({ selectedSource: this.props.sourceId })
  }

  onClose = () => {
    this.setState({})
  }

  onOpen = (type) => {
    this.setState({})
  }

  onConfirm = () => {
    const { selectedSource } = this.state
    this.props.onConfirm(selectedSource)
  }

  onChange = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  getSubscriptionPricing(subscription) {
    let rows = []
    let totalCost = 0
    const plan = subscription.plan
    if (plan) {
      let first = true
      let quantity = subscription.quantity
      let minRange = 1
      if (plan.tiers) {
        plan.tiers.forEach((element) => {
          const maxQuantity = element.up_to
          const flatAmount = element.flat_amount != null ? element.flat_amount / 100 : 0
          const unitAmount = element.unit_amount != null ? element.unit_amount / 100 : 0
          let currentQuantity
          if (maxQuantity && maxQuantity < quantity) {
            currentQuantity = maxQuantity
          } else {
            currentQuantity = quantity
          }
          quantity -= currentQuantity
          const amount = currentQuantity * unitAmount + flatAmount
          totalCost += amount
          let description
          if (first) {
            first = false
            description = 'For the first ' + minRange
            if (minRange !== maxQuantity) {
              description += ' to ' + maxQuantity
            }
          } else if (maxQuantity == null) {
            description = 'For the rest'
          } else {
            description = 'For the next ' + minRange + ' to ' + maxQuantity
          }
          rows.push({
            description: description,
            quantity: currentQuantity,
            unitPrice: '$ ' + unitAmount,
            amount: '$ ' + amount,
          })
          minRange = maxQuantity
        })
      }
    }
    return {
      totalCost: totalCost,
      rows: rows,
    }
  }

  render() {
    const { forwardedRef, subscription, sourceList } = this.props

    const { selectedSource } = this.state

    const created = moment.unix(subscription.created).format('MM/DD/YYYY')
    const periodStart = moment.unix(subscription.current_period_start).format('MM/DD/YYYY')
    const periodEnd = moment.unix(subscription.current_period_end).format('MM/DD/YYYY')

    const pricingPlan = this.getSubscriptionPricing(subscription)
    return (
      <ModalDialog
        title={'Subscription Detail'}
        ref={forwardedRef}
        onConfirm={this.onConfirm}
        onClose={this.onClose}
        onOpen={this.onOpen}
        // hideSave={true}
      >
        <Grid container spacing={3}>
          <Grid item lg={5} className="margin">
            <InputLabel>Product: </InputLabel>
            <EditableTextField
              value={subscription.plan.nickname}
              valueToRender={subscription.plan.nickname}
              editMode={false}
            />
          </Grid>
          <Grid item lg={6} className="margin">
            <InputLabel>Quantity: </InputLabel>
            <EditableTextField
              value={subscription.quantity}
              valueToRender={subscription.quantity}
              editMode={false}
            />
          </Grid>
          <Grid item lg={5} className="margin">
            <InputLabel>Created: </InputLabel>
            <EditableTextField value={created} valueToRender={created} editMode={false} />
          </Grid>
          <Grid item lg={6} className="margin">
            <InputLabel>Current Period: </InputLabel>
            <EditableTextField
              value={periodStart + ' - ' + periodEnd}
              valueToRender={periodStart + ' - ' + periodEnd}
              editMode={false}
            />
          </Grid>
          <Grid item lg={12} className="margin">
            <Text>Pricing</Text>
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Description</TableCell>
                    <TableCell style={this.centerAlign}>Quantity</TableCell>
                    <TableCell style={this.centerAlign}>Unit Price</TableCell>
                    <TableCell>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pricingPlan.rows.map((row, index) => {
                    return (
                      <TableRow>
                        <TableCell>{row.description}</TableCell>
                        <TableCell style={this.centerAlign}>
                          {numberWithCommas(row.quantity)}
                        </TableCell>
                        <TableCell style={this.centerAlign}>
                          {numberWithCommas(row.unitPrice)}
                        </TableCell>
                        <TableCell>{numberWithCommas(row.amount)}</TableCell>
                      </TableRow>
                    )
                  })}
                  <TableRow>
                    <TableCell colSpan={3}>Total Cost:</TableCell>
                    <TableCell>{'$ ' + numberWithCommas(pricingPlan.totalCost)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>
          <Grid item lg={12} className="margin">
            <InputLabel>Payment Source: </InputLabel>
            <Select
              style={{ width: '30%' }}
              value={selectedSource}
              onChange={this.onChange('selectedSource')}
            >
              {sourceList.map((row, index) => {
                return (
                  <MenuItem key={index} value={row.value}>
                    {row.label}
                  </MenuItem>
                )
              })}
            </Select>
            {/* <Text>Payment Source:</Text> */}
          </Grid>
        </Grid>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(SubscriptionModal)



// WEBPACK FOOTER //
// ./src/components/Modal/SubscriptionModal.js